// extracted by mini-css-extract-plugin
export default {"container":"ImageGenerator_container__q-HIC","content":"ImageGenerator_content__6pPbK","text":"ImageGenerator_text__Ei1Kl","downloadButton":"ImageGenerator_downloadButton__clH1t"};